module.exports = __webpack_public_path__ + "img/animals_deer.b9f9dbff.png";